import { adgAdDefaultConfig } from './default';

// eslint-disable-next-line import/prefer-default-export
export const adgAdConfig = {
    sample: {
        gamingLarge: {
            ...adgAdDefaultConfig,
            id: '88799',
            displayid: '1',
            adType: 'LARGE',
        },
        gamingSmall: {
            ...adgAdDefaultConfig,
            id: '91830',
            displayid: '1',
            adType: 'SP',
        },
        result: {
            ...adgAdDefaultConfig,
            id: '88804',
            displayid: '2',
            adType: 'RECT',
        },
        ready: {
            ...adgAdDefaultConfig,
            id: '91825',
            displayid: '2',
            adType: 'INFEED',
        },
        retry: {
            ...adgAdDefaultConfig,
            id: '91825',
            displayid: '2',
            adType: 'INFEED',
        },
        reward: {
            ...adgAdDefaultConfig,
            id: '91825',
            displayid: '2',
            adType: 'INFEED',
        },
    },
};
